export default "__VITE_ASSET__Nt98Jz5W__"